import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./ModelPage.scss";
import { motion } from "framer-motion";
// import { TypeAnimation } from "react-type-animation";
import TypeIt from "typeit-react";
import { sectionVariants } from "../../styles/animationVars";
import BrandSection from "../../components/Branding/BrandSection";
import MetaTagsSeo from "../../components/Shared/MetaTagsSeo";
function ModelPage() {
  return (
    <>
      <MetaTagsSeo
        title="FROI – Model"
        description="FROI’s models establishes key five themes as the basis for assessing , developing and transforming the governnment human capital ecosystem  into a future-ready one."
        keywords={[
          "FUTURE READY ORGANIZATION INSTITUTE",
          "Future Ready",
          "Future Ready Organization",
          "Future Ready Government",
          "Future Readiness Standards for Government Human Capital Practices",
          "Human Capital Future Readiness",
          "Future Readiness Index",
          "Government Human Capital Future Readiness Accreditation",
          "Future Readiness Accreditation",
          "Government Human Capital Future Readiness Index",
          "Future Readiness Research & Studies",
          "FROI's Future Ready Government Human Capital Model",
        ].join(", ")}
        OGDescription="FROI’s models establishes key five themes as the basis for assessing , developing and transforming the governnment human capital ecosystem  into a future-ready one."
        url="https://www.froiglobal.org/"
      />
      <motion.section className="froi_section">
        <Container>
          <TypeIt
            element="h1"
            className="froi_title"
            options={{
              speed: 50,
              waitUntilVisible: true,
              cursor: false,
              lifeLike: true,
            }}
          >
            FROI’s Future Ready Government Human Capital{" "}
            <span className="marked_word model-appear">Model</span>™
          </TypeIt>

          <div>
            <BrandSection
              text={
                <>
                  Developed by Centre for Research & Studies,{" "}
                  <span className="no-break"> Future-Ready</span> GOV Human
                  Capital, FROI’s Future Ready Government Human Capital Model™
                  is structured around a comprehensive,{" "}
                  <span className="no-break">science-paced</span> architecture
                  that establishes the global reference for building
                  future-ready government human capital ecosystems.
                </>
              }
              brandImg="./images/model/Model_Logo.png"
              brandName="froi_model_logo"
            />
            <p className="froi_text">
              <strong>
                FROI’s
                {/* <span className="marked_word">I</span> */}
              </strong>{" "}
              models establishes key five themes as the basis for assessing,
              developing and transforming the governnment human capital
              ecosystem into a <span className="no-break">future-ready</span>{" "}
              one.
            </p>
          </div>
        </Container>
      </motion.section>
      <section className="froi_section model_section">
        <Container>
          <Row>
            <Col lg={7} xs={12}>
              <div className="model_img">
                <motion.img
                  initial={{ opacity: 0, x: -60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.8,
                    ease: "easeOut",
                  }}
                  src="./images/model/FROI_Model.png"
                  alt="froi_model"
                />
              </div>
            </Col>
            <Col lg={5} xs={12}>
              <div className="model_img model_img_message">
                <motion.img
                  src="./images/model/FROI_Model_page_message.png"
                  alt="froi_model_message"
                  initial={{ opacity: 0, x: 60 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ amount: 0.2 }}
                  transition={{
                    duration: 0.8,
                    delay: 0.2,
                    ease: "easeOut",
                  }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <motion.section
        className="froi_section model_Accreditation"
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{
          amount: 0.2,
        }}
      >
        <Container>
          <p className="froi_text_large">
            The Model serves as the inspiration source for the integrated{" "}
            <a href="/froi-accreditation">Accreditation</a> framework
          </p>
        </Container>
      </motion.section>
    </>
  );
}

export default ModelPage;
